import { useCallback } from 'react';
import { css } from '@emotion/react';
import * as RadixDropdownMenu from '@radix-ui/react-dropdown-menu';
import { buttonStyle, primaryButtonStyle, dangerButtonStyle } from 'client/components/Button/Button';

interface DropdownMenuButtonProps extends Omit<RadixDropdownMenu.DropdownMenuItemProps, 'onSelect'> {
  id: string;
  primary?: boolean;
  danger?: boolean;
  onSelect?: (id: string) => void;
}

export const DropdownMenuButton = ({ id, primary, danger, onSelect, ...props }: DropdownMenuButtonProps) => {
  const handleSelect = useCallback(() => !!onSelect && onSelect(id), [id, onSelect]);

  return (
    <RadixDropdownMenu.Item
      css={[buttonStyle, dropdownButtonStyle, primary && primaryButtonStyle, danger && dangerButtonStyle]}
      onSelect={handleSelect}
      {...props}
    />
  );
};

const dropdownButtonStyle = css`
  outline: none;
`;
